import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c916b26"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_2 = { class: "modal__header" }
const _hoisted_3 = { class: "modal__header__title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-close" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "modal__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_outline_button = _resolveComponent("outline-button")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["modal", [_ctx.modalTypeClass, _ctx.modalSize]])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "title", {}, undefined, true)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "m-0",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
              }, _hoisted_5)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]),
          (!_ctx.hideButtons)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(`modal__buttons ${_ctx.buttonsClass}`)
              }, [
                _renderSlot(_ctx.$slots, "buttons", {}, undefined, true),
                _createVNode(_component_outline_button, {
                  onClick: _ctx.handleConfirmClick,
                  disabled: _ctx.blockConfirm
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "confirm-button", {}, () => [
                      _createTextVNode(_toDisplayString(_ctx.$t('general.apply')), 1)
                    ], true)
                  ]),
                  _: 3
                }, 8, ["onClick", "disabled"]),
                (!_ctx.hideCancelButton)
                  ? (_openBlock(), _createBlock(_component_outline_button, {
                      key: 0,
                      onClick: _ctx.close,
                      type: "outline"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('general.cancel')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true)
        ], 2)
      ]))
    : _createCommentVNode("", true)
}